import { render, staticRenderFns } from "./TagInput_v1.vue?vue&type=template&id=3c276d78&scoped=true&lang=pug"
import script from "./TagInput_v1.vue?vue&type=script&lang=js"
export * from "./TagInput_v1.vue?vue&type=script&lang=js"
import style0 from "./TagInput_v1.vue?vue&type=style&index=0&id=3c276d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c276d78",
  null
  
)

export default component.exports